<!--
  Provision runs table (04-frontend.md §3). A single QL table widget; a row click opens the
  run detail - build shape of the bm precedent bm-billing-runs.component.html.
-->
@if (initialized) {
    <div class="cp-provision-runs grid">
        <div class="col-12">

            @if (jobRunning) {
                <div class="flex align-items-center gap-2 mb-3 p-3 border-round-xl bg-orange-100 text-orange-800">
                    <i class="fa-solid fa-spinner fa-spin"></i>
                    <span class="text-sm">
                        Hintergrundprozesse laufen – die Laufliste wird nach Abschluss automatisch aktualisiert.
                    </span>
                </div>
            }

            <!-- The visible way to create a run. Until now the only one was the widget's "…" menu
                 -> "Anlegen", whose generic dialog neither says that it creates nor which period. -->
            <div class="flex justify-content-end mb-3">
                <p-button label="Neuer Provisionslauf"
                          icon="fa-solid fa-plus"
                          severity="primary"
                          (onClick)="openCreateDialog()">
                </p-button>
            </div>

            @if (provisionRunsWidget) {
                <mvs-widget
                        [widgetData]="provisionRunsWidget"
                        (onFieldObjectSelect)="handleObjectSelect($event)">
                </mvs-widget>
            }
        </div>
    </div>

    <cp-run-create-dialog
            [(visible)]="createDialogVisible"
            (provisionRunCreated)="handleProvisionRunCreated($event)">
    </cp-run-create-dialog>
}
